import { Icon, IconColor } from '../../common';
import * as styles from './UploadIcon.module.css';

export function UploadIcon(props: { color?: IconColor; icon: string }) {
    return (
        <div className={styles.uploadIcon}>
            <Icon
                color={props.color || IconColor.secondary}
                icon={props.icon}
            />
        </div>
    );
}
